import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import SearchInput from "../../../components/shared/SearchInput";
import api from "../../../utils/api";

export default function SearchDiagnostics() {
  const [search, setSearch] = useState("");
  const [testType, setTestType] = useState("");

  const { data, isLoading } = useQuery(
    ["search-diagnostics", search, testType],
    () =>
      api.get(`/patient/search-labs?search=${search}&testType=${testType}`)
  );

  const { data: testTypes } = useQuery("test-types", () =>
    api.get("/patient/test-types")
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap gap-3">
        <SearchInput
          value={search}
          onChange={setSearch}
          placeholder="Search labs or tests…"
          className="w-72"
        />
        <select
          value={testType}
          onChange={(e) => setTestType(e.target.value)}
          className="input-field w-auto"
        >
          <option value="">All Test Types</option>
          {testTypes?.testTypes?.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-16">
          <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(data?.labs || []).map((lab) => (
            <div key={lab.id} className="card hover:shadow-md transition-shadow">
              <div className="flex items-start gap-3">
                <div className="text-3xl">🧪</div>
                <div className="flex-1">
                  <h3 className="font-display font-semibold text-slate-800">{lab.name}</h3>
                  <p className="text-slate-500 text-xs mt-1">{lab.address}</p>
                  {/* <div className="flex flex-wrap gap-1 mt-2">
                    {(lab?.availableTests || []).slice(0, 3).map((t) => (
                      <span key={t} className="badge-info">{t}</span>
                    ))}
                  </div> */}
                  <div className="mt-3 flex gap-2">
                    <Link
                      to={`/patient/book-diagnostic/${lab.id}`}
                      className="btn-primary text-xs px-3 py-1.5"
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
